import React from "react";
import { Sparkles, Play, X, Clock } from "lucide-react";
import { Button } from "./ui/button";

export default function TourBanner({ onStart, onDismiss }) {
  return (
    <div
      className="relative overflow-hidden rounded-lg border border-accent/30 bg-accent/[0.06] p-4 sm:p-5 flex flex-col sm:flex-row sm:items-center gap-4"
      data-testid="tour-banner"
    >
      <div className="absolute -right-8 -top-10 h-32 w-32 rounded-full bg-accent/10 blur-2xl pointer-events-none" />
      <div className="h-11 w-11 shrink-0 rounded-full bg-accent/15 border border-accent/30 grid place-items-center">
        <Sparkles className="h-5 w-5 text-accent" />
      </div>
      <div className="min-w-0 flex-1">
        <div className="font-display text-lg font-bold tracking-tight flex items-center gap-2">
          New here? Watch the 60-second tour
          <span className="inline-flex items-center gap-1 text-[10px] text-muted-foreground font-normal"><Clock className="h-3 w-3" /> ~1 min</span>
        </div>
        <p className="text-sm text-muted-foreground mt-0.5">
          A quick guided run through the 6 modules that matter most — Control Tower, data import, reporting, scorecard, emissions &amp; readiness.
        </p>
      </div>
      <div className="flex items-center gap-2 shrink-0">
        <Button variant="primary" size="sm" onClick={onStart} data-testid="tour-start-btn">
          <Play className="h-3.5 w-3.5" /> Start tour
        </Button>
        <Button variant="ghost" size="sm" onClick={onDismiss} data-testid="tour-dismiss-btn" aria-label="Dismiss tour">
          <X className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}
